import styled from '@emotion/styled';
import theme from 'src/styles/theme';
import {Grid} from '@mui/material';

export const DicomContainer = styled.div``;

export const MainContainer = styled('div')<{height?: string}>`
  display: flex;
  border-radius: 8px;
  height: ${({height}) => (height ? height : '70vh')};
`;

export const MainDicomViewContainer = styled(Grid)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  border: 1px solid ${theme.palette.grey[300]};
  border-radius: 8px;
  background-color: #f4f6f8; 
`;

export const MainNoInfoContainer = styled('div')<{height?: string}>`
  display: flex;
  justify-content: center;
  border: 1px solid ${theme.palette.grey[300]};
  border-radius: 8px;
  height: ${({height}) => (height ? height : '70vh')};
  background-color: #f4f6f8;
`;

export const MainTreeViewContainer = styled(Grid)`
  flex: 1;
  max-width: 30%;
  overflow: hidden;
`;

export const TreeViewContainer = styled(Grid)<{
    shoulddisplaymetainfo: string;
    isdochidden?: boolean;
    height?: string
  }>`
    display: ${({shoulddisplaymetainfo}) =>
      shoulddisplaymetainfo === 'true' ? 'none' : 'block'};
    padding: 0.25rem;
    background-color: #f4f6f8;
    min-width: ${({isdochidden}) => (isdochidden === undefined ? '10rem' : '')};
    height: ${({height}) => (height ? height : '70vh')};
    width: ${({isdochidden}) => (isdochidden ? '100%' : '97%')};
    overflow-y: auto;
    overflow-x: auto;
    border: 1px solid ${theme.palette.grey[300]};
    border-radius: 8px;
  
    /* Customize scrollbar */
    scrollbar-width: thin;
    scrollbar-color: #bdbbbb #e3e1e1;
    border-radius: 8px;
    &::-webkit-scrollbar {
      width: 8px;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-track {
      background: #f4f6f8;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${theme.palette.primary.main};
      border-radius: 8px;
      border: 2px solid #f4f6f8;
    }
  `;
